// Normalizes legacy draft data field IDs and values to align with current isetFormConfig question IDs.
// - Maps old hyphenated / renamed keys to new snake_case IDs.
// - Converts legacy radio boolean/integer representations (1/0, true/false) to 'yes'/'no' when target expects yes/no.
// Extend the mapping below as more legacy keys are discovered.

const legacyKeyMap = {
  // Eligibility (legacy hyphenated / mixed identifiers)
  'example-radio-4': 'eligibility_is_indigenous',
  'eligibility-indigenous': 'eligibility_is_indigenous',
  'eligibility-female': 'eligibility_gender',
  'eligibility-canadian': 'eligibility_citizenship',
  'eligibility-age': 'eligibility_age',
  'eligibility-employment': 'eligibility_employment_status',
  'eligibility_employment': 'eligibility_employment_status', // mixed legacy underscore variant
  'eligibility-training': 'eligibility_pursuing_training',
  'eligibility-financial': 'eligibility_funding_gap',
  'eligibility-disqualified': 'eligibility_previous_default',

  // Personal details
  'social-insurance-number': 'sin_number',
  'last-name': 'last_name',
  'first-name': 'first_name',
  'middle-names': 'middle_names',
  'preferred-name': 'preferred_name'
  // Extend with further mappings as more legacy keys are encountered
};

// Fields that are yes/no radios in new config (used to coerce numeric/boolean legacy values)
const yesNoFields = new Set([
  'eligibility_is_indigenous',
  'eligibility_gender',
  'eligibility_citizenship',
  'eligibility_age',
  'eligibility_employment_status',
  'eligibility_pursuing_training',
  'eligibility_funding_gap'
]);

function coerceYesNo(value) {
  if (value === undefined || value === null) return value;
  if (value === 1 || value === '1' || value === true) return 'yes';
  if (value === 0 || value === '0' || value === false) return 'no';
  return value; // already string yes/no or something else
}

export function normalizeLegacyFields(raw) {
  if (!raw || typeof raw !== 'object') return raw;
  const normalized = { ...raw };
  Object.entries(legacyKeyMap).forEach(([legacyKey, newKey]) => {
    if (normalized[newKey] === undefined && normalized.hasOwnProperty(legacyKey)) {
      let val = normalized[legacyKey];
      if (yesNoFields.has(newKey)) {
        val = coerceYesNo(val);
      }
      normalized[newKey] = val;
    }
  });

  // Generic hyphen -> underscore fallback (non-destructive)
  Object.keys(normalized).forEach(k => {
    if (k.includes('-')) {
      const candidate = k.replace(/-/g, '_');
      if (!normalized.hasOwnProperty(candidate)) {
        normalized[candidate] = normalized[k];
      }
    }
  });

  // Coerce any existing yes/no numeric/boolean fields already using new IDs
  yesNoFields.forEach(f => {
    if (normalized.hasOwnProperty(f)) {
      normalized[f] = coerceYesNo(normalized[f]);
    }
  });

  return normalized;
}

export { legacyKeyMap };
